import { Fetch } from '.';
import { View } from '../types';
import { Metadata } from '../types/Metadata';
import { WorkspacePermissions } from '../types/Permission';

export interface Payload {
  empCd: number;
  roles: string[];
  workspaceRefId: string;
  maxResults: number;
  filters: View.FiltersField[];
}

export const deletePermission =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'empCd' | 'workspaceRefId'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/permission', 'DELETE');

export const upsertPermission =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'empCd' | 'workspaceRefId' | 'roles'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/permission', 'PUT');

export const searchPermission =
  (f: Fetch) =>
  async (
    payload: Pick<Payload, 'workspaceRefId' | 'maxResults' | 'filters'>
  ): Promise<Metadata[]> =>
    f.fetchJSON<Metadata[]>(payload, '/admin/permission', 'POST');

export const getPermissions =
  (f: Fetch) => async (): Promise<WorkspacePermissions> =>
    f.getJSON<WorkspacePermissions>('/admin/permission');
